import React from 'react';
import VoiceOverArtistsComponent from '../components/VoiceOverArtists';

import { AddonsContextConsumer } from '../../../../context/AddonsContext';

function VoiceOverArtists(props) {
  return (
    <AddonsContextConsumer>
      {
      ({
        actions: { getBillingEntityCode }
      }) =>
      <VoiceOverArtistsComponent
        {...props}
        getBillingEntityCode={getBillingEntityCode} />}


    </AddonsContextConsumer>);

}

export default VoiceOverArtists;